import { FC } from 'react';
import { useCountdownTimer } from '../../hooks/use-countdown-timer';

export const CountdownTimer: FC<{
  targetDate: Date;
  onComplete?: VoidFunction;
}> = ({ targetDate, onComplete }) => {
  const timeLeft = useCountdownTimer(targetDate, onComplete);

  return <span>{timeLeft}</span>;
};
